import React from "react";

const ACGasLeakage = () => {
  return (
    <div className="container mx-auto px-6 py-12">
      <h1 className="text-3xl font-bold">AC Gas Leakage Repair</h1>
      <p className="mt-4">
        We detect and repair AC gas leaks, perform safe refrigerant top-ups,
        and test systems to prevent future leaks.
      </p>
    </div>
  );
};

export default ACGasLeakage;

